export default __webpack_public_path__ + "static/media/Strengths-Badge.5252cbab.gif";